import { Box, Grid } from "@mui/material";
import NavCard from "components/NavCard";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { useIntl } from "react-intl";

const ScormPage = () => {
  const { formatMessage: t } = useIntl();
  const {
    deactivateRusticiCoursesUrl,
    addExportCoursesUrl,
    exportedScormFilesUrl,
    generateScormMetadataUrl,
  } = useGlobalContext();

  useTitle(t({ id: "scorm" }));

  return (
    <Box my={4}>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={4}>
          <NavCard
            title={t({ id: "deactivateRusticiCourses" })}
            url={deactivateRusticiCoursesUrl()}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <NavCard
            title={t({ id: "addExportCourses" })}
            url={addExportCoursesUrl()}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <NavCard
            title={t({ id: "exportedScormFiles" })}
            url={exportedScormFilesUrl()}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <NavCard
            title={t({ id: "generateScormMetadata" })}
            url={generateScormMetadataUrl()}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ScormPage;
